import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models (FD110 / FD111 / FD112~FD116)
// ============================================================

export interface FD110 {
  fd110_01: string;          // 採購單號 (PK)
  fd110_10: string;          // 單據類型
  fd110_11: string | null;   // 日期
  fd110_12: string;          // 分包商代號
  fd110_13: string;          // 收貨公司代號
  fd110_14: string;          // 交易條件名稱
  fd110_141: string;         // 交易條件代號
  fd110_15: string;          // 付款條件名稱
  fd110_151: string;         // 付款條件代號
  fd110_16: string;          // 包裝方式代號
  fd110_161: string;         // 包裝方式說明
  fd110_17: string;
  fd110_18: string;
  fd110_19: string;          // 幣別
  fd110_20: number;          // 匯率
  fd110_23: number;          // 原幣總金額
  fd110_24: number;          // 折算金額
  fd110_25: string;
  fd110_28: string;          // 購貨類別
  fd110_29: string;          // 結案狀態
  fd110_30: string;          // QC人員代號
  fd110_31: string;          // 採購人員代號
  fd110_32: string;          // 部門代碼
  fd110_33: string;          // 收貨公司代號
  fd110_34: string;          // 跳號前置碼/AD_KEY
  fd110_40: number;          // 表單類型
  fd110_42: string;          // 備註
  fd110_421: string;         // 備註代號
  fd110_43: number;          // 總項數
  fd110_44: string;          // 品質要求代號
  fd110_441: string;         // 品質要求內容
  fd110_46: string;          // 原料/半成品/成品
  fd110_47: string | null;
  fd110_48: string | null;
  fd110_50: number;
  fd110_51: string;
  fd110_53: string;
  fd110_41?: string;         // SHIPPING MARK
  fd110_45?: string;         // 樣布需要量
  fd110_55: boolean;         // 三聯發票
  fd110_71: string;
  fd110_72: string;
  fd110_73: string;
  fd110_80: string;          // 核准狀態
  fd110_90: number;          // 版本號
  fd110_91: string;          // 建檔人員
  fd110_92: string | null;   // 建檔日期
  fd110_93: string;          // 修改人員
  fd110_94: string;

  // Associations
  details?: FD111[];
  colors?: FD112[];
  expenses?: FD113[];
  attachments?: FD114[];
  quotations?: FD115[];
  inspections?: FD116[];
}

export interface FD111 {
  fd111_01: string;          // 採購單號(FK)
  fd111_02: number;          // 項次
  fd111_10: string;          // 產品代號前段
  fd111_11: string;          // 產品代號後段
  fd111_12: string;          // 產品名稱
  fd111_13: string;
  fd111_14: number;
  fd111_15: number;          // 採購數量
  fd111_16: string;          // 單位
  fd111_17: number;          // 採購單價
  fd111_18: number;          // 金額
  fd111_19: string | null;   // 預定交期
  fd111_20?: number;         // 累計交貨量 (readonly)
  fd111_21?: number;         // 累計驗貨數量 (readonly)
  fd111_22?: number;         // 累計確認數量 (readonly)
  fd111_24: number;
  fd111_25: number;          // 折扣單價
  fd111_26: number;          // 應付單價
  fd111_27: string;          // 驗貨方式
  fd111_28?: string;         // 工廠布號
  fd111_29: string;          // ASSORT(Y/N)
  fd111_30: number;          // 允收數量
  fd111_301: number;         // 允收比率
  fd111_302: number;         // 允收增加量
  fd111_31: number;
  fd111_32: number;
  fd111_33: number;
  fd111_34: number;
  fd111_35: number;
  fd111_36: number;
  fd111_37: number;
  fd111_38: number;
  fd111_39: number;
  fd111_40: number;          // 其他費用
  fd111_401: number;
  fd111_51: string;          // 產品規格
  fd111_52: string;          // 加工別
  fd111_53: string;          // 幅寬(針孔內)
  fd111_54: string;          // 幅寬(針孔外)
  fd111_55: string;          // 碼重
  fd111_56: string;          // 米平方重
  fd111_57: string;
}

export interface FD112 {
  fd112_01: string;
  fd112_02: number;
  fd112_03: number;
  fd112_11: string;
  fd112_12: string;
  fd112_13: number;
  fd112_14: number;
  fd112_15: string;
  fd112_16: string;
}

export interface FD113 {
  fd113_01: string;
  fd113_02: number;
  fd113_03: number;
  fd113_11: string;
  fd113_12: number;
  fd113_13: string;
  fd113_14: number;
  fd113_15: number;
  fd113_90: number;
  fd113_91: string;
  fd113_92: string | null;
  fd113_93: string;
}

export interface FD114 {
  fd114_01: string;
  fd114_02: number;
  fd114_11: string;
  fd114_12: string;
  fd114_90: number;
}

export interface FD115 {
  fd115_01: string;
  fd115_02: number;
  fd115_03: number;
  fd115_11: string;
  fd115_12: string;
  fd115_13: number;
  fd115_14: number;
  fd115_15: number;
  fd115_90: number;
}

export interface FD116 {
  fd116_01: string;
  fd116_02: number;
  fd116_03: number;
  fd116_11: string;
  fd116_12: string;
  fd116_13: string;
  fd116_14: string;
  fd116_15: string;
}

// ============================================================
// Request / Response types
// ============================================================

export interface D211ListResponse {
  data: FD110[];
  total: number;
  page: number;
  size: number;
}

export interface D211CreateRequest {
  master: Partial<FD110>;
  details: Partial<FD111>[];
  colors?: Partial<FD112>[];
  expenses?: Partial<FD113>[];
  attachments?: Partial<FD114>[];
  quotations?: Partial<FD115>[];
  inspections?: Partial<FD116>[];
}

export interface ValidationError {
  field: string;
  rule?: string;
  message: string;
}

export interface ApprovalHistoryEvent {
  id: number;
  action: string;
  actor_id: string;
  actor_name: string;
  comment: string;
  old_status: string;
  new_status: string;
  created_at: string;
}

// ============================================================
// API methods
// ============================================================

const BASE = '/api/pwd211';

export const d211Api = {
  async list(page = 1, size = 200, keyword?: string): Promise<D211ListResponse> {
    const params: Record<string, unknown> = { page, size };
    if (keyword) params.keyword = keyword;
    const res = await apiClient.get(BASE, { params });
    return res.data;
  },

  async get(id: string): Promise<FD110> {
    const res = await apiClient.get(`${BASE}/${encodeURIComponent(id)}`);
    return res.data;
  },

  async create(data: D211CreateRequest): Promise<FD110> {
    const res = await apiClient.post(BASE, data);
    return res.data;
  },

  async update(id: string, data: D211CreateRequest): Promise<FD110> {
    const res = await apiClient.put(`${BASE}/${encodeURIComponent(id)}`, data);
    return res.data;
  },

  async delete(id: string): Promise<void> {
    await apiClient.delete(`${BASE}/${encodeURIComponent(id)}`);
  },

  // Approval workflow
  async submitForApproval(id: string): Promise<{ message: string }> {
    const res = await apiClient.post(`${BASE}/${encodeURIComponent(id)}/submit`);
    return res.data;
  },

  async approve(id: string, comment?: string): Promise<{ message: string }> {
    const res = await apiClient.post(`${BASE}/${encodeURIComponent(id)}/approve`, { comment: comment || '' });
    return res.data;
  },

  async reject(id: string): Promise<{ message: string }> {
    const res = await apiClient.post(`${BASE}/${encodeURIComponent(id)}/reject`);
    return res.data;
  },

  async writeoff(id: string, comment?: string): Promise<{ message: string }> {
    const res = await apiClient.post(`${BASE}/${encodeURIComponent(id)}/writeoff`, { comment: comment || '' });
    return res.data;
  },

  async getApprovalHistory(id: string): Promise<ApprovalHistoryEvent[]> {
    const res = await apiClient.get(`${BASE}/${encodeURIComponent(id)}/history`);
    return res.data.events || [];
  },

  // Lookup: get display name for a reference table code
  async lookupName(type: string, code: string): Promise<string> {
    if (!code || !code.trim()) return '';
    try {
      const res = await apiClient.get(`${BASE}/lookup/${encodeURIComponent(type)}/${encodeURIComponent(code.trim())}`);
      return res.data.name || '';
    } catch {
      return '';
    }
  },
};
